import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'management-reports-sales-products-buying-options',
  storeModule.createStoreModule('management-reports-sales-products-buying-options')
)
